import { Box, Button, Container, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

/**
 * Call to action section
 */
const CtaSection = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: (t) => t.palette.primary.main,
        color: 'white',
        py: 8,
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Ready to Equip Your Team?
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          Protect your people. Strengthen your response. Build confidence in
          every classroom, boardroom, and hallway.
        </Typography>
        <Button
          variant="contained"
          size="large"
          sx={{
            backgroundColor: 'white',
            color: 'black',
            textTransform: 'none',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#dbdbdb',
            },
          }}
          component={Link}
          to="/purchase-training"
        >
          Get Started Now
        </Button>
        <Typography marginTop={3}>
          Questions about pricing or deployment?{' '}
          <Link to="/contact" style={{ color: theme.palette.text.primary }}>
            Contact us
          </Link>{' '}
          and we&apos;ll walk you through it.
        </Typography>
      </Container>
    </Box>
  );
};

export default CtaSection;
